// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { RemoveBlockedUsersMenu } from './remove-blocked-users-menu'

const COMPONENT_ID = 'removeBlockedUsersMenu'

interface Prop {
  userId: string
}

export const showRemoveBlockedUsersMenu = (
  props: Prop,
  preventBackClick = false,
) => addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: RemoveBlockedUsersMenu },
}
